import { InjectionToken } from '@angular/core';

/**
 * Injection token to provide the
 */
export const CONNECTED_PLAYER_CLOSE_REQUEST = new InjectionToken<() => void>(
  'bmat.angular.media-players.connected-player-close-request',
);
